


































import { Component, Vue } from 'vue-property-decorator';

interface Quote {
  text: string;
  author: string;
}

@Component
export default class App extends Vue {
  private quotes: Quote[] = [
    { text: 'With great power comes great responsibility', author: 'Uncle Ben? idk' },
    { text: 'That\'s one small step for a man, one giant leap for mankind', author: 'Neil Armstrong' },
    { text: 'Small loan of a millon dollars', author: 'Donald J. Trump' },
    { text: 'It drowned', author: 'Vladimir Putin' },
  ];
  private primaryColorHue: number = 0;
  private currQuote: Quote = this.quotes[0];
  private created() {
    this.changeQuote();
  }
  private changeQuote(): void {
    let nextQuoteInd: number = Math.floor(Math.random() * this.quotes.length);
    if (nextQuoteInd === this.quotes.indexOf(this.currQuote)) {
      const lastQuoteInd = this.quotes.length - 1;
      if (nextQuoteInd === lastQuoteInd) {
        nextQuoteInd = 0;
      } else {
        nextQuoteInd++;
      }
    }
    this.currQuote = this.quotes[nextQuoteInd];

    this.primaryColorHue = Math.floor(Math.random() * 360);
  }
  get tweetButtonHref(): string {
    const queryText = encodeURI(`"${this.currQuote.text}" – ${this.currQuote.author}`);
    const queryHashtags = 'quotes,freeCodeCamp,VueJS';
    return `https://twitter.com/intent/tweet?text=${queryText}&hashtags=${queryHashtags}`;
  }
  get primaryColor() { return `hsl(${this.primaryColorHue}, 40%, 30%)`; }
}
